export const MALE = 'male';
export const FEMALE = 'female';
export const BOTH = 'both';

export const genderTypes = [MALE, FEMALE];
export const genderPreferencesTypes = [MALE, FEMALE, BOTH];



// WEBPACK FOOTER //
// ./src/sources/constants/gender.js